import React, { useState, useEffect } from "react";
import { omLogo } from "../../assets/images/";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Typography, InputAdornment, IconButton } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../js/reducers/snackbar";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { OAuth as OAuthActions } from "../../js/actions";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import TokenStorage from "../../js/utils/tokenStorage";

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem",
    boxSizing: "border-box",
  },
  loginCard: {
    position: "relative",
    width: "100%",
    maxWidth: "420px",
    padding: "2rem",
    borderRadius: "24px",
    background: "rgba(255, 255, 255, 0.72)",
    backdropFilter: "blur(22px)",
    WebkitBackdropFilter: "blur(22px)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    boxShadow:
      "0 20px 60px rgba(3, 46, 79, 0.28), inset 0 1px 0 rgba(255,255,255,0.6)",
    animation: "$cardFadeIn 0.6s ease",
    [theme.breakpoints.down("xs")]: {
      padding: "2rem 1.5rem",
      borderRadius: "20px",
    },
  },
  "@keyframes cardFadeIn": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  logo: {
    height: "64px",
    width: "auto",
    objectFit: "contain",
  },
  field: {
    marginBottom: "1.25rem",
    "& .MuiInputBase-root": {
      margin: "0 !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px !important",
      background: "rgba(255,255,255,0.65)",
      transition: "box-shadow 0.25s ease, background 0.25s ease",
      "& fieldset": {
        borderColor: "rgba(11, 60, 93, 0.15)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(3, 169, 243, 0.5)",
      },
      "&.Mui-focused": {
        background: "rgba(255,255,255,0.95)",
        boxShadow: "0 6px 18px rgba(3, 169, 243, 0.18)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#03A9F3",
        borderWidth: "1.5px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "16.5px 2px",
      fontSize: "0.90em !important",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#0288d1",
    },
  },
  inputIcon: {
    color: "#7a8b96",
  },
  loginButton: {
    padding: "0.6rem",
    borderRadius: "14px",
    fontWeight: 700,
    fontSize: "0.95rem !important",
    letterSpacing: "0.03em",
    textTransform: "none",
    color: "#fff",
    background: "linear-gradient(135deg, #0288d1 0%, #0B4759 100%)",
    display: "flex",
    justifyContent: "center",
    margin: "0.5rem auto",
    width: "30%",
    "&:hover": {
      background: "linear-gradient(135deg, #03A9F3 0%, #0B4759 100%)",
    },
  },
  forgotLink: {
    display: "block",
    textAlign: "center",
    cursor: "pointer",
    color: "#0288d1",
    fontSize: "0.85rem !important",
    fontWeight: 600,
    marginTop: "1.4rem",
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#0B4759",
      textDecoration: "underline",
    },
  },
}));

const CardLogin = ({ onForgotPassword }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailHelper, setEmailHelper] = useState("");
  const [passwordHelper, setPasswordHelper] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    const token = TokenStorage.getToken();
    const cookieData = TokenStorage.getMultiTabData();
    if (token) {
      axios.defaults.headers.common["Authorization"] =
        cookieData.token_type + " " + cookieData.access_token;
      dispatch(OAuthActions.multiTabCookieHandler(cookieData)).then(() => {
        history.push(window._appConstants.useCommonDefaults.navRef.dashboard);
      });
    }
  }, []);

  const onChange = (event) => {
    switch (event.target.id) {
      case "email":
        setEmail(event.target.value);
        const emailValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          event.target.value
        );
        if (!emailValid && event.target.value.length !== 0) {
          setEmailHelper("Invalid email address");
        } else {
          setEmailHelper("");
        }
        break;
      case "password":
        setPassword(event.target.value);
        const passwordValid = /(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
          event.target.value
        );
        if (!passwordValid && event.target.value.length !== 0) {
          setPasswordHelper(
            "The password must contain at least 1 number,1 special character(!,@,#,$,%,^,&,*) and must be at least 8 characters in length"
          );
        } else {
          setPasswordHelper("");
        }
        break;
    }
  };
  const history = useHistory();
  const submit = () => {
    if (
      email.length &&
      password.length &&
      emailHelper.length === 0 &&
      passwordHelper.length === 0
    ) {
      dispatch(OAuthActions.getOAuthToken(email, password)).then(function (
        loginSuccess
      ) {
        if (loginSuccess["error"] === undefined) {
          dispatch(OAuthActions.getLoginUser(loginSuccess.user_uid)).then(
            function (userDetailsSuccess) {
              if (userDetailsSuccess.make == null) {
                TokenStorage.setCurrentMakeSelected({
                  uid: "",
                  name: "Not Selected",
                });
              } else
                TokenStorage.setCurrentMakeSelected(userDetailsSuccess.make);
              history.push(window._appConstants.useCommonDefaults.navRef.dashboard);

              dispatch(setSnackbar(true, "success", "Login Successful"));
            }
          );
        } else {
          dispatch(
            setAlertDialog(
              true,
              null,
              "error",
              "Login",
              "Login unsuccessful. Please check your username and password. If account locked, please click on the forgot password link to reset your password.\nDetails Of Failure: " +
              loginSuccess.error_description,
              "OK",
              ""
            )
          );
        }
      });
    } else {
      if (email.length === 0) {
        setEmailHelper("Please enter email");
      }
      if (password.length === 0) {
        setPasswordHelper("Please enter password");
      }
    }
  };

  return (
    <div className={classes.parentDiv}>
      <div className={classes.loginCard}>
        <div className={classes.logoWrap}>
          <img src={omLogo} alt="login_logo" className={classes.logo} />
        </div>

        <TextField
          fullWidth
          required
          variant="outlined"
          className={classes.field}
          error={emailHelper.length !== 0}
          helperText={emailHelper}
          id="email"
          // label="Username"
          placeholder="Email ID"
          value={email}
          onChange={(event) => onChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutlineOutlinedIcon className={classes.inputIcon} />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          required
          variant="outlined"
          className={classes.field}
          error={passwordHelper.length !== 0}
          helperText={passwordHelper}
          id="password"
          // label="Password"
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          onChange={(event) => onChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon className={classes.inputIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          size="large"
          id="loginClick"
          variant="contained"
          className={classes.loginButton}
          onClick={submit}
        >
          Login
        </Button>

        <Typography className={classes.forgotLink} onClick={onForgotPassword}>
          Forgot Password / New Registration?
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(CardLogin);
